import {useEffect, useState} from 'react'

import {differenceInCalendarDays} from 'date-fns/fp'

import {ServerDate, convertToDate} from '$utils/date'

import MyAssetTooltipGradation from './MyAssetTooltipGradation'

interface ExpireNotificationTooltipProps {
    expDate: string
}

const ExpireNotificationTooltip = ({expDate}: ExpireNotificationTooltipProps) => {
    const serverDateTime = ServerDate()
    const [isShowTooltip, setShowTooltip] = useState(false)
    const leftDays = differenceInCalendarDays(serverDateTime, convertToDate(expDate))

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setShowTooltip(false)
        }, 10000)

        return () => {
            clearTimeout(timeoutId)
        }
    }, [])

    useEffect(() => {
        setShowTooltip(leftDays <= 15)
    }, [expDate, leftDays])

    if (!isShowTooltip) {
        return null
    }

    return (
        <MyAssetTooltipGradation
            direction={'top'}
            edgePosition={{right: 14}}
            tooltipPosition={{right: 20, top: '100%', marginTop: -10}}
        >
            {leftDays < 0 ? '만기일지남' : leftDays === 0 ? '만기일오늘' : `만기 D-${leftDays}`}
        </MyAssetTooltipGradation>
    )
}

export default ExpireNotificationTooltip
